import {
    Flex,
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import React from 'react';
import { Link, useMatches } from 'react-router-dom';
import { Icon, IconsNames } from 'shared';
import { matchesInfo } from '../libs/matches-info';

type BreadcrumbProps = GridProps & React.RefAttributes<HTMLDivElement>

// const pageInfos = {
//     catering: {
//         title: 'Кейтеринг',
//     },
//     'catering_event-format': {
//         title: 'Форматы меро',
//         parent: 'catering',
//     },
// };

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
    ...props
}) => {
    const matches = useMatches();

    return (
        <Grid
            background="#E74C3C"
            {...props}
        >
            <Flex
                padding="1rem 2rem"
                flexDirection="row"
                gap="1rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
                color="white"
            >
                <Link to="/">
                    <Grid
                        width="fit-content"
                        templateColumns="auto 1fr"
                        gap="0.5rem"
                    >
                        <Grid
                            margin="auto 0"
                        >
                            <Icon
                                iconName={IconsNames.Home}
                                color="white"
                                height="1rem"
                            />
                        </Grid>
                        <Text margin="auto 0">
                            Главная
                        </Text>
                    </Grid>
                </Link>
                {matchesInfo[matches[0].id] && (
                    <>
                        {matchesInfo[matches[0].id].prev.map(({
                            name,
                            path,
                        }) => (
                            <Link to={path}>
                                <Grid
                                    width="fit-content"
                                    templateColumns="auto 1fr"
                                    gap="1rem"
                                >
                                    <Text margin="auto 0">
                                        –
                                    </Text>
                                    <Text margin="auto 0">
                                        {name}
                                    </Text>
                                </Grid>
                            </Link>
                        ))}
                        <Link to={matches[0].pathname}>
                            <Grid
                                width="fit-content"
                                templateColumns="auto 1fr"
                                gap="1rem"
                            >
                                <Text margin="auto 0">
                                    –
                                </Text>
                                <Text margin="auto 0">
                                    {matchesInfo[matches[0].id].current.name}
                                </Text>
                            </Grid>
                        </Link>
                    </>
                )}
            </Flex>
        </Grid>
    );
};
